import * as S from './styled'

const ClearButton = ({ onClick }) => (
  <S.ClearButton onClick={onClick}>
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.021 4L8 1.021 6.979 0 4 2.979 1.106 0 0 1.106 2.979 4 0 6.979 1.021 8 4 5.021 6.979 8 8 6.979 5.021 4z"
        fill="currentColor"
      />
    </svg>
  </S.ClearButton>
)

export default ClearButton
